import { DOC_HOST } from '../../../base/constants/cgi-base';
// 增加独立密码
export var ADD_INDEPENDENT_PWD = "".concat(DOC_HOST, "/online_docs_cgi/pwd/add");
// 停用独立密码
export var DEL_INDEPENDENT_PWD = "".concat(DOC_HOST, "/online_docs_cgi/pwd/del");
// 验证独立密码
export var VERIFY_INDEPENDENT_PWD = "".concat(DOC_HOST, "/online_docs_cgi/pwd/verify");
// 修改独立密码
export var RESET_INDEPENDENT_PWD = "".concat(DOC_HOST, "/online_docs_cgi/pwd/reset");
// 获取手机验证码
export var GET_VERIFY_CODE = "".concat(DOC_HOST, "/online_docs_cgi/pwd/verify_code_get");
// 验证手机验证码
export var CHECK_VERIFY_CODE = "".concat(DOC_HOST, "/online_docs_cgi/pwd/verify_code_check");
// 验证独立密码问题
export var CHECK_PWD_QUESTION = "".concat(DOC_HOST, "/online_docs_cgi/pwd/question_check");
// 获取独立密码问题
export var GET_PWD_QUESTION = "".concat(DOC_HOST, "/online_docs_cgi/pwd/question_get");
// 获取独立密码的一些标志信息
export var GET_PWD_TIPS = "".concat(DOC_HOST, "/online_docs_cgi/pwd/tips_get");
// 校验独立密码token是否过期
export var TOKEN_VERIFY = "".concat(DOC_HOST, "/online_docs_cgi/pwd/token_verify");
// 设置独立密码提示又展示了一次
export var SET_PWD_TIPS = "".concat(DOC_HOST, "/online_docs_cgi/pwd/tips_report");
